var map = {
	"./aqua@2x.png": 72197,
	"./blue@2x.png": 6193,
	"./cyan@2x.png": 64998,
	"./darkMagenta@2x.png": 86234,
	"./darkOrange@2x.png": 42163,
	"./darkRed@2x.png": 49738,
	"./deepPink@2x.png": 79303,
	"./forestGreen@2x.png": 5013,
	"./gold@2x.png": 65451,
	"./greenSea@2x.png": 65471,
	"./magenta@2x.png": 270,
	"./orange@2x.png": 87927,
	"./pink@2x.png": 43153,
	"./red@2x.png": 67254,
	"./residence@2x.png": 91637,
	"./skyBlue@2x.png": 73004,
	"./yellowGreen@2x.png": 16682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49959;